import { defineMessages } from '@cookbook/solid-intl'

// Split out of `contact-page.messages.en.js` so the router's document-title/meta-
// description wiring doesn't have to eagerly pull that entire page's messages file
// into the boot-critical chunk just for these strings. Same pattern/rationale as
// `tos-page-routing.messages.en.js` / `privacy-page-routing.messages.en.js`
// (TENANT-5036 bundle audit).
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'Discover how to get in touch with Lodgr. Reach out for support, questions, or help with booking and hosting. Connect with our team and get the answers you need.',
        id: 'ContactPage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'Contact Us | Lodgr',
        id: 'ContactPage.titleMessage',
    }),
}
